import React from 'react';

function ContentDetailHero({
  title,
  imageUrl,
  meta,
  badges = null,
  actions = null,
  variant = 'default',
  children = null,
}) {
  const heroClassName = [
    'platform-content-detail-hero',
    variant !== 'default' && `platform-content-detail-hero--${variant}`,
  ].filter(Boolean).join(' ');

  const showGradientBackdrop = !imageUrl && variant !== 'qna';

  return (
    <header className={heroClassName}>
      {imageUrl ? (
        <div className="platform-content-detail-hero__media">
          <img src={imageUrl} alt="" loading="lazy" />
          <div className="platform-content-detail-hero__scrim" aria-hidden="true" />
        </div>
      ) : showGradientBackdrop ? (
        <div className="platform-content-detail-hero__backdrop" aria-hidden="true" />
      ) : null}

      <div className="platform-content-detail-hero__body">
        {variant === 'qna' ? (
          <>
            <div className="platform-content-detail-hero__head">
              <h1 className="platform-content-detail-hero__title">{title}</h1>
              {actions ? (
                <div className="platform-content-detail-hero__actions">{actions}</div>
              ) : null}
            </div>
            {meta ? (
              <div className="platform-content-detail-hero__meta">{meta}</div>
            ) : null}
            {children}
          </>
        ) : (
          <>
            {actions ? (
              <div className="platform-content-detail-hero__actions">{actions}</div>
            ) : null}
            {badges ? (
              <div className="platform-content-detail-hero__badges">{badges}</div>
            ) : null}
            <h1 className="platform-content-detail-hero__title">{title}</h1>
            {meta ? (
              <div className="platform-content-detail-hero__meta">{meta}</div>
            ) : null}
            {children}
          </>
        )}
      </div>
    </header>
  );
}

export default ContentDetailHero;
